import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64')
];

export const server_loads = [];

export const dictionary = {
		"/": [19],
		"/about": [52],
		"/(authenticated)/account": [42,[2,12]],
		"/(authenticated)/account/[tab]": [43,[2,12,13]],
		"/confirm": [53],
		"/(authenticated)/dashboard": [44,[2]],
		"/docs/[...slug]": [54],
		"/(authenticated)/experimental": [45,[2,14]],
		"/(authenticated)/experimental/agents": [46,[2,14,15]],
		"/(authenticated)/experimental/agents/[tab]": [47,[2,14,15]],
		"/(authenticated)/experimental/float": [48,[2,14]],
		"/(authenticated)/experimental/hewsync": [49,[2,14,16]],
		"/(authenticated)/experimental/queue": [50,[2,14,17]],
		"/(authenticated)/experimental/raw-email": [51,[2,14]],
		"/features": [55],
		"/forgot-password": [56],
		"/iframe": [57],
		"/login-as": [59],
		"/login": [58],
		"/logout": [60],
		"/markdown-preview": [61],
		"/reset-password": [62],
		"/share": [63,[],[18]],
		"/signup": [64],
		"/(authenticated)/[organization=organization]": [20,[2,3]],
		"/(authenticated)/[organization=organization]/api": [23,[2,3,6]],
		"/(authenticated)/[organization=organization]/api/[kind]/[id]/[[tab]]": [24,[2,3,6,7,8]],
		"/(authenticated)/[organization=organization]/dashboard": [25,[2,3]],
		"/(authenticated)/[organization=organization]/project/[id]/atom": [27,[2,3,9,11]],
		"/(authenticated)/[organization=organization]/project/[id]/atom/chats/[chat]": [29,[2,3,9,11]],
		"/(authenticated)/[organization=organization]/project/[id]/atom/lafourche-prototype": [30,[2,3,9,11]],
		"/(authenticated)/[organization=organization]/project/[id]/atom/library": [31,[2,3,9,11]],
		"/(authenticated)/[organization=organization]/project/[id]/atom/library/[type]": [32,[2,3,9,11]],
		"/(authenticated)/[organization=organization]/project/[id]/atom/library/[type]/[item]": [33,[2,3,9,11]],
		"/(authenticated)/[organization=organization]/project/[id]/atom/plans/[plan]": [34,[2,3,9,11]],
		"/(authenticated)/[organization=organization]/project/[id]/atom/reports/[report]": [35,[2,3,9,11]],
		"/(authenticated)/[organization=organization]/project/[id]/atom/[...path]": [28,[2,3,9,11]],
		"/(authenticated)/[organization=organization]/project/[id]/files": [36,[2,3,9]],
		"/(authenticated)/[organization=organization]/project/[id]/files/[...path]": [37,[2,3,9]],
		"/(authenticated)/[organization=organization]/project/[id]/lafourche-dashboard": [38,[2,3,9]],
		"/(authenticated)/[organization=organization]/project/[id]/lafourche-weather-map": [39,[2,3,9]],
		"/(authenticated)/[organization=organization]/project/[id]/lafourche-weather-map/[tab=lafourcheWeatherMapTab]": [40,[2,3,9]],
		"/(authenticated)/[organization=organization]/project/[id]/lafourche-weather-map/[tab=lafourcheWeatherMapTab]/[alertId]": [41,[2,3,9]],
		"/(authenticated)/[organization=organization]/project/[id]/[...page]": [26,[2,3,9,10]],
		"/(authenticated)/[organization=organization]/[slug=perms]": [21,[2,3,4]],
		"/(authenticated)/[organization=organization]/[slug=perms]/[id]/[[tab]]": [22,[2,3,4,5]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';